import { createContext } from "react";

export const ArticulosModelosContext = createContext()
export const ArticulosModelosFormContext = createContext()
export const ArticulosModelosReportContext = createContext()